/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { Fade } from 'react-awesome-reveal';

import Header from 'parts/Header';
import Footer from 'parts/Footer';
import Team from 'assets/images/hero/team.png';

export default class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <section className="hero sm:items-center lg:items-start sm:flex-row">
          <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
            <Fade direction="up" triggerOnce>
              <h1 className="text-6xl text-theme-blue font-bold leading-tight mb-5">About Us</h1>
            </Fade>
            <Fade direction="up" delay={300} triggerOnce>
              <p className="font-light text-xl text-gray-400 leading-relaxed">
                We build robust digital products — ERP solutions, stone crusher management,
                custom websites, and mobile apps — backed by a passionate team and 24/7 support.
              </p>
            </Fade>
          </div>
          <div className="flex pt-5 w-full justify-center items-center order-first md:w-full lg:order-last lg:w-1/2">
            <Fade direction="top-right" triggerOnce delay={300}>
              <img src={Team} alt="About Zerlak" />
            </Fade>
          </div>
        </section>

        <section className="container mx-auto px-6 lg:px-0">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 bg-white rounded-2xl shadow border border-light-theme-purple">
              <h3 className="text-xl text-theme-blue mb-2">Our Mission</h3>
              <p className="text-gray-400">Deliver reliable software that grows with your business.</p>
            </div>
            <div className="p-6 bg-white rounded-2xl shadow border border-light-theme-purple">
              <h3 className="text-xl text-theme-blue mb-2">Our Values</h3>
              <p className="text-gray-400">Communication, collaboration, and quality in every project.</p>
            </div>
            <div className="p-6 bg-white rounded-2xl shadow border border-light-theme-purple">
              <h3 className="text-xl text-theme-blue mb-2">What We Do</h3>
              <p className="text-gray-400">ERP, stone crusher management, web/mobile development, and digital marketing.</p>
            </div>
          </div>
        </section>

        <Footer />
      </>
    );
  }
}
